const LOGIN_OPTIONS = {
  TITLE: `Log in to Growsari`,
  LOGIN_OTP_BUTTON: "Login via OTP",
  LOGIN_MPIN_BUTTON: "Login via MPIN",
  ACCOUNT_STATUS_MESSAGE: `Loading available verification methods. Please wait!`,
  GENERATE_OTP_MESSAGE: "Sending OTP to your mobile number. Please wait!",
  PRIMARY_CTA: "Send OTP via SMS",
  SECONDARY_CTA: "Enter 4-digit password",
  OTP_VIA_VOICE_CALL_CTA: "Send OTP via Voice Call",
  subText: "Para manatiling secure ang\naccount, pumili ng paraan\nupang mag-log in",
  flashText: "Success! Napalitan ang password ",
  flashSubText: "Tandaan ito at huwag sabihin sa iba.",
  LOGIN_METHODS_CONFIG: {
    VIA_MPIN: {
      CTA_LABEL: "4-digit password",
      DISABLED_CTA_LABEL: "Password unavailable",
      CTA_ICON_SVG: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect x="0.5" y="0.5" width="7" height="5" rx="2" fill="white"/>
        <rect x="0.5" y="6.5" width="7" height="5" rx="2" fill="white" fill-opacity="0.65"/>
        <rect x="0.5" y="12.5" width="7" height="5" rx="2" fill="white"/>
        <rect x="8.5" y="0.5" width="7" height="5" rx="2" fill="white" fill-opacity="0.65"/>
        <rect x="8.5" y="6.5" width="7" height="5" rx="2" fill="white" fill-opacity="0.65"/>
        <rect x="8.5" y="12.5" width="7" height="5" rx="2" fill="white" fill-opacity="0.65"/>
        <rect x="8.5" y="18.5" width="7" height="5" rx="2" fill="white"/>
        <rect x="16.5" y="0.5" width="7" height="5" rx="2" fill="white" fill-opacity="0.65"/>
        <rect x="16.5" y="6.5" width="7" height="5" rx="2" fill="white"/>
        <rect x="16.5" y="12.5" width="7" height="5" rx="2" fill="white" fill-opacity="0.65"/>
        </svg>`,
      CTA_ICON_BG: "#ED5A29",
    },
    VIA_SMS_OTP: {
      CTA_LABEL: "OTP via text",
      DISABLED_CTA_LABEL: "OTP via text unavailable",
      CTA_ICON_SVG: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_1710_154064)">
        <path d="M0 3C0 1.34531 1.34531 0 3 0H21C22.6547 0 24 1.34531 24 3V16.5C24 18.1547 22.6547 19.5 21 19.5H14.4984L8.7 23.85C8.475 24.0187 8.17031 24.0469 7.9125 23.9203C7.65469 23.7937 7.5 23.5359 7.5 23.25V19.5H3C1.34531 19.5 0 18.1547 0 16.5V3ZM9.51094 6.7875C9.20625 6.89062 9 7.17656 9 7.5V12C9 12.4125 9.3375 12.75 9.75 12.75C10.1625 12.75 10.5 12.4125 10.5 12V9.75L11.4 10.95C11.5406 11.1375 11.7656 11.25 12 11.25C12.2344 11.25 12.4594 11.1375 12.6 10.95L13.5 9.75V12C13.5 12.4125 13.8375 12.75 14.25 12.75C14.6625 12.75 15 12.4125 15 12V7.5C15 7.17656 14.7938 6.89062 14.4891 6.7875C14.1844 6.68438 13.8469 6.79219 13.65 7.05L12 9.24844L10.35 7.05C10.1578 6.79219 9.82031 6.68438 9.51094 6.7875ZM17.625 8.56875C17.625 8.51719 17.6344 8.49375 17.6437 8.47969C17.6578 8.46094 17.6859 8.42344 17.7562 8.38594C17.9016 8.30156 18.1313 8.24531 18.3609 8.25C18.6469 8.25469 18.9656 8.31562 19.3031 8.40937C19.7016 8.51719 20.1141 8.27813 20.2219 7.87969C20.3297 7.48125 20.0906 7.06875 19.6922 6.96094C19.3078 6.85781 18.8531 6.75938 18.3844 6.75469C17.9484 6.75 17.4281 6.84375 16.9922 7.10156C16.5281 7.37813 16.1203 7.87031 16.125 8.58281C16.1297 9.27188 16.5375 9.70781 16.9547 9.96094C17.3109 10.1766 17.7563 10.3078 18.0938 10.4109L18.15 10.4297C18.5484 10.5516 18.8156 10.6406 18.9938 10.7531C19.1203 10.8328 19.1203 10.8656 19.1203 10.8984V10.9078C19.1203 10.9828 19.1062 11.0156 19.0922 11.0344C19.0781 11.0578 19.05 11.0906 18.9938 11.1281C18.8625 11.2078 18.6422 11.2641 18.3937 11.2594C18.0656 11.25 17.7609 11.1469 17.3344 11.0016C17.2641 10.9781 17.1844 10.95 17.1047 10.9266C16.7109 10.7953 16.2891 11.0062 16.1578 11.4C16.0266 11.7937 16.2375 12.2156 16.6312 12.3469C16.6875 12.3656 16.7531 12.3891 16.8187 12.4125C17.2312 12.5531 17.775 12.7406 18.3469 12.7594C18.8062 12.7734 19.3406 12.6844 19.7859 12.4031C20.2641 12.1031 20.6297 11.5922 20.6203 10.8891C20.6109 10.2 20.2219 9.75469 19.7953 9.4875C19.4203 9.25312 18.9563 9.1125 18.6141 9.00937L18.5859 9C18.1828 8.87813 17.9109 8.79375 17.7328 8.68125C17.6578 8.63437 17.6344 8.60625 17.6297 8.60156C17.6297 8.59688 17.6297 8.59219 17.6297 8.58281L17.625 8.56875ZM4.875 8.56875C4.875 8.51719 4.88438 8.49375 4.89375 8.47969C4.90781 8.46094 4.93594 8.42344 5.00625 8.38594C5.15156 8.30156 5.38125 8.24531 5.61094 8.25C5.92031 8.25469 6.39375 8.325 6.70312 8.40937C7.10156 8.51719 7.51406 8.27813 7.62188 7.87969C7.72969 7.48125 7.49063 7.06875 7.09219 6.96094C6.67969 6.84844 6.07969 6.75938 5.63437 6.75469C5.19844 6.75 4.67812 6.84375 4.24219 7.10156C3.77813 7.37344 3.375 7.86562 3.375 8.57812C3.37969 9.26719 3.7875 9.70312 4.20469 9.95625C4.56094 10.1719 5.00625 10.3031 5.34375 10.4062L5.4 10.425C5.79844 10.5469 6.06562 10.6359 6.24375 10.7484C6.37031 10.8281 6.37031 10.8609 6.37031 10.8937V10.9031C6.37031 10.9781 6.35625 11.0109 6.34219 11.0297C6.32812 11.0531 6.3 11.0859 6.24375 11.1234C6.1125 11.2031 5.89219 11.2594 5.64375 11.2547C5.30625 11.2453 4.97812 11.1328 4.53281 10.9828C4.47187 10.9641 4.40625 10.9406 4.34062 10.9172C3.94687 10.7859 3.525 10.9969 3.39375 11.3906C3.2625 11.7844 3.47344 12.2063 3.86719 12.3375C3.91875 12.3563 3.97969 12.375 4.03594 12.3937C4.45781 12.5391 5.01562 12.7312 5.59219 12.75C6.05156 12.7641 6.58594 12.675 7.03125 12.3937C7.50938 12.0938 7.875 11.5828 7.86563 10.8797C7.85625 10.1906 7.46719 9.74531 7.04062 9.47812C6.66562 9.24375 6.20156 9.10312 5.85938 9L5.83125 8.99063C5.42812 8.86875 5.15625 8.78438 4.97344 8.67188C4.89844 8.625 4.875 8.59688 4.87031 8.59219C4.87031 8.5875 4.87031 8.58281 4.87031 8.57344L4.875 8.56875Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_1710_154064">
        <rect width="24" height="24" fill="white"/>
        </clipPath>
        </defs>
        </svg>`,
      CTA_ICON_BG: "#00B7A8",
    },
    VIA_VOICE_OTP: {
      CTA_LABEL: "OTP via voice call",
      DISABLED_CTA_LABEL: "Voice call unavailable",
      CTA_ICON_SVG: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M26.6247 21.4582L25.6247 25.6665C25.4997 26.2915 24.9997 26.7082 24.3747 26.7082C13.8747 26.6665 5.33301 18.1249 5.33301 7.62487C5.33301 6.99987 5.70801 6.49987 6.33301 6.37487L10.5413 5.37487C11.1247 5.24987 11.7497 5.58321 11.9997 6.12487L13.958 10.6665C14.1663 11.2082 14.0413 11.8332 13.583 12.1665L11.333 13.9999C12.7497 16.8749 15.083 19.2082 17.9997 20.6249L19.833 18.3749C20.1663 17.9582 20.7913 17.7915 21.333 17.9999L25.8747 19.9582C26.4163 20.2499 26.7497 20.8749 26.6247 21.4582Z" fill="white"/>
        </svg>`,
      CTA_ICON_BG: "#6E7191",
    },
  },
  INSTRUCTIONS_TEXT: `Para sa iyong seguridad, kailangan\npatunayan na ikaw ang may ari nitong\naccount. Pumili ng verification method:`,
  LOGIN_METHOD_CTA_HEADER: `Verify account to log in`,
};

const OTP_MINUTES = 5;

const OTP_DELIVERY_CHANNEL = {
  call: "call",
  sms: "sms",
};

const OTP_DELIVERY_CONFIG = {
  call: {
    label: "voice call",
    promptModalConfig: {
      TITLE: `Send OTP via voice call to `,
      PRIMARY_CTA: "Call me",
      SECONDARY_CTA: "Use other methods",
      INSTRUCTION: `Pakinggan at tandaan ang binigay na OTP.
      1 tawag lang pwede kada araw.  Libre ang tawag na ito.`,
    },
  },
  sms: {
    label: "text",
  },
};

const SMART_MOBILE_NUMBER = "09190564444";

const DEFAULT_ACTIVITY_PAGE_LIMIT = 20;
const DEFAULT_SEARCH_PAGE_LIMIT = 20;

const ORDER_STATUS: Record<string, string> = {
  CANCELLED: "Cancelled",
  CANCEL_CONFIRMED: "Cancelled",
  REJECTED: "Cancelled",

  EXCLUSIVE_LOCAL_PENDING: "Pending",

  APPROVED: "Placed",
  PENDING: "Placed",
  IN_GROWSARI_FMCG_SYSTEM: "Placed",

  READY_TO_PACK: "Processing",
  AWAITING_BOX_COUNT: "Processing",
  PARTIAL_PACKED: "Processing",
  PICKING_STARTED: "Processing",
  SECOND_SCAN_STARTED: "Processing",
  PROCESSING: "Processing",

  PACKED: "Packed",
  PROCESSED: "Packed",

  READY_TO_REDISPATCH: "Redelivery",
  REDELIVER: "Redelivery",

  DISPATCHED: "OnTheWay",

  DELIVERED: "Delivered",
};

const CURRENCY_UNIT = `₱`;
const Pesos = "\u20B1";

const ITEM_IN_CART = {
  subtitle: "Gusto mo bang tanggalin ang item na ito?",
  primaryBtn: "Remove item",
  secondaryBtn: "Cancel",
};

const MISSION_TYPES = {
  Ordering: "Ordering",
  EServices: "E-Services",
  Others: "Others",
};

const VOUCHERS_GROUPING = {
  CartVouchers: {
    title: "Paninda",
    description: "Isang paninda promo bawat transaction",
    type: "Heading",
    showSubHeading: true,
  },
  OtherVouchers: {
    title: "Other Paninda Deals",
    description: "Ma-aapply ang promo kapag naabot ang requirement",
    type: "Heading",
    showSubHeading: true,
  },
  ENegosyoMissions: {
    title: "E-Negosyo Deals",
    description: "Mag-transact sa E-Negosyo at manalo ng iba’t ibang premyo!",
    type: "Heading",
    showSubHeading: true,
    isMission: true,
    classification: MISSION_TYPES.EServices,
  },
};

export {
  OTP_MINUTES,
  LOGIN_OPTIONS,
  OTP_DELIVERY_CHANNEL,
  OTP_DELIVERY_CONFIG,
  SMART_MOBILE_NUMBER,
  DEFAULT_ACTIVITY_PAGE_LIMIT,
  ORDER_STATUS,
  CURRENCY_UNIT,
  DEFAULT_SEARCH_PAGE_LIMIT,
  ITEM_IN_CART,
  Pesos,
  VOUCHERS_GROUPING,
};
